<script lang="ts">
  import { getContext } from 'svelte'
  import { twMerge } from 'tailwind-merge'
  type TitleType = {
    id?: string
    title?: string
  }
  type DescType = {
    id?: string
    desc?: string
  }

  interface BaseProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    role?: string
    color?: string
    withEvents?: boolean
    onclick?: (event: MouseEvent) => void
    onkeydown?: (event: KeyboardEvent) => void
    onkeyup?: (event: KeyboardEvent) => void
  }

  interface CtxType extends BaseProps {}
  interface Props extends BaseProps {
    title?: TitleType
    desc?: DescType
    ariaLabel?: string
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  }

  const ctx: CtxType = getContext('iconCtx') ?? {}
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8'
  }

  export let size: Props['size'] = ctx.size || 'md'
  export let role: Props['role'] = ctx.role || 'img'
  export let color: Props['color'] = ctx.color || 'currentColor'
  //export let withEvents: Props['withEvents'] = ctx.withEvents || false
  export let title: TitleType = {}
  export let desc: DescType = {}

  let ariaDescribedby = `${title.id || ''} ${desc.id || ''}`
  let hasDescription = false

  $: if (title.id || desc.id) {
    hasDescription = true
  } else {
    hasDescription = false
  }
  export let ariaLabel = 'archive solid'
  export let strokeWidth = 2
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  {...$$restProps}
  class={twMerge('shrink-0', sizes[size ?? 'md'], $$props.class)}
  {role}
  aria-label={ariaLabel}
  aria-describedby={hasDescription ? ariaDescribedby : undefined}
  viewBox="0 0 132 132"
>
  {#if title.id && title.title}
    <title id={title.id}>{title.title}</title>
  {/if}
  {#if desc.id && desc.desc}
    <desc id={desc.id}>{desc.desc}</desc>
  {/if}
  <path
    d="M0 0 C50.16 0 100.32 0 152 0 C152 50.16 152 100.32 152 152 C101.84 152 51.68 152 0 152 C0 101.84 0 51.68 0 0 Z "
    fill="#24323F"
    transform="translate(0,0)"
  />
  <path
    d="M0 0 C2.61476784 1.83773778 4.89983171 3.81413499 7.234375 5.99609375 C15.07270712 13.60417016 15.07270712 13.60417016 24.484375 18.74609375 C24.39744359 16.95350817 24.28926996 15.16194231 24.171875 13.37109375 C24.11386719 12.37335938 24.05585937 11.375625 23.99609375 10.34765625 C23.82722656 9.48914062 23.65835938 8.630625 23.484375 7.74609375 C22.494375 7.08609375 21.504375 6.42609375 20.484375 5.74609375 C20.109375 3.24609375 20.109375 3.24609375 20.484375 0.74609375 C23.90767351 -1.53610526 25.32575168 -1.55131788 29.359375 -1.56640625 C30.90238281 -1.59154297 30.90238281 -1.59154297 32.4765625 -1.6171875 C35.8397412 -1.2109854 37.7323633 -0.17828344 40.484375 1.74609375 C40.234375 3.55859375 40.234375 3.55859375 39.484375 5.74609375 C38.82002441 6.13039551 38.15567383 6.51469727 37.47119141 6.91064453 C35.13329762 8.68732234 35.13329762 8.68732234 34.97021484 12.12841797 C34.94245346 13.51895341 34.93546444 14.91000359 34.9453125 16.30078125 C34.93351959 17.03934357 34.92172668 17.77790588 34.90957642 18.53884888 C34.87427866 20.89981071 34.86514694 23.25988959 34.859375 25.62109375 C34.84299909 27.97489028 34.82085964 30.32829314 34.78775024 32.68191528 C34.76822417 34.14541523 34.75877408 35.60909464 34.76083374 37.07272339 C34.71951674 41.0545222 34.35594712 44.20160103 32.484375 47.74609375 C30.65625 48.8125 30.65625 48.8125 28.484375 48.74609375 C26.1875 47.0859375 26.1875 47.0859375 23.734375 44.68359375 C19.95899089 41.08745636 16.16388185 37.90717459 11.8828125 34.9375 C11.42132813 34.54433594 10.95984375 34.15117188 10.484375 33.74609375 C10.484375 33.08609375 10.484375 32.42609375 10.484375 31.74609375 C9.906875 31.47796875 9.329375 31.20984375 8.734375 30.93359375 C6.484375 29.74609375 6.484375 29.74609375 4.484375 28.18359375 C2.4168008 26.6975248 0.93615091 26.28241973 -1.515625 25.74609375 C-1.45556909 27.85105339 -1.36677141 29.9552081 -1.265625 32.05859375 C-1.21921875 33.23035156 -1.1728125 34.40210938 -1.125 35.609375 C-0.81508351 38.84088057 -0.81508351 38.84088057 1.53125 40.6640625 C2.17578125 41.02113281 2.8203125 41.37820312 3.484375 41.74609375 C3.234375 44.12109375 3.234375 44.12109375 2.484375 46.74609375 C-0.62537164 48.83590055 -3.32390844 49.04338063 -7.015625 49.05859375 C-7.9540625 49.07535156 -8.8925 49.09210938 -9.859375 49.109375 C-12.89817553 48.69377434 -14.25624673 47.76567951 -16.515625 45.74609375 C-15.88243337 41.06047568 -15.88243337 41.06047568 -13.99536133 39.44311523 C-11.84838066 36.98087094 -12.14316903 35.13203175 -12.15234375 31.90625 C-12.15298828 30.76091797 -12.15363281 29.61558594 -12.15429688 28.43554688 C-12.17041016 27.23865234 -12.18652344 26.04175781 -12.203125 24.80859375 C-12.19990234 23.61556641 -12.19667969 22.42253906 -12.19335938 21.19335938 C-12.00418872 14.14378537 -12.00418872 14.14378537 -14.515625 7.74609375 C-16.54879507 6.01183602 -16.54879507 6.01183602 -18.515625 4.74609375 C-18.328125 2.87109375 -18.328125 2.87109375 -17.515625 0.74609375 C-12.66070367 -2.38611356 -5.10633286 -2.54523734 0 0 Z "
    fill="#FBFBFB"
    transform="translate(55.515625,53.25390625)"
  />
</svg>
